import { get } from 'lodash';

export const getToken = (state) => get(state?.login, 'userInfo.userData', null);

export const getBrokage_id = (state) => get(state?.login?.userInfo, 'brokage_id', null);
